type HighlightTextProps = {
	children?: string;
	highlight?: string;
};

const HighlightText = ({ children, highlight }: HighlightTextProps) => {
	if (!highlight || !children) return null;

	const regex = new RegExp(`(${highlight})`, 'gi');
	const parts = children.split(regex);

	return (
		<>
			{parts.map((part, index) => {
				const key = `${index}-${part}`;
				const isHighlight = part.toLowerCase() === highlight.toLowerCase();

				return isHighlight ? (
					<span key={key} className="font-bold text-mantang-primary">
						{part}
					</span>
				) : (
					<span key={key}>{part}</span>
				);
			})}
		</>
	);
};

export default HighlightText;
